import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import CloseButton from 'components/CloseButton';
import Button from 'components/Button';
import Text from 'components/Text';
import { getText } from 'helpers/i18n';

import './moveToList.styles.scss';

export default class MoveToList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
        };
    }

    componentDidMount() {
        Modal.setAppElement('#one-checkout');
    }

    onToggleListSelection(value) {
        this.setState({
            modalOpen: value,
        });
    }

    render() {
        const { availableLists, text, selectedList } = this.props;
        const expectedMinimumLists = 1;

        if (typeof availableLists === 'undefined' || Object.keys(availableLists).length <= expectedMinimumLists) {
            return null;
        }

        return (
            <div className="movetolist">
                <Button
                    onClick={this.showModalOrMoveDirectly.bind(this)}
                    text={text || 'product_move_to_list_label'}
                    theme="secondary-blue"
                />
                <Modal
                    isOpen={this.state.modalOpen}
                    onRequestClose={this.onToggleListSelection.bind(this, false)}
                    contentLabel={getText('list_selector_headline')}
                    className="one-checkout ikea-modal__content"
                    overlayClassName="ikea-modal__overlay"
                >
                    <CloseButton onClick={this.onToggleListSelection.bind(this, false)} container="modal" />
                    <h2><Text textKey="product_move_to_list_label" /></h2>
                    <ul className="movetolist__list">
                        {
                            Object.keys(availableLists).map(list => {
                                if (selectedList && selectedList.toString() === list.toString()) {
                                    return null;
                                }
                                return <li key={list}>
                                    <Button
                                        data-value={list}
                                        theme="link"
                                        translate={false}
                                        text={availableLists[list].name}
                                        onClick={this.moveItemToList.bind(this)}
                                    />
                                </li>;
                            })
                        }
                    </ul>
                </Modal>
            </div>
        );
    }

    moveItemToList(event) {
        const { move, articleData, selectedList } = this.props;

        const toList = event.currentTarget.dataset.value;
        if (toList) {
            move(articleData, toList, selectedList, true);
            this.onToggleListSelection(false);
        }
    }

    showModalOrMoveDirectly() {
        const { availableLists, move, articleData, selectedList } = this.props;

        if (Object.keys(availableLists).length === 1) {
            const toList = Object.keys(availableLists)[0];
            move(articleData, toList, selectedList, true);
        } else {
            this.onToggleListSelection(true);
        }
    }
}

MoveToList.propTypes = {
    availableLists: PropTypes.object,
    article: PropTypes.any.isRequired,
    articleData: PropTypes.object.isRequired,
    selectedList: PropTypes.any,
    move: PropTypes.func.isRequired,
    text: PropTypes.string,
};

